import root from 'window-or-global';
import {GraphQlService} from '@epic-node-services/graphql-public-service';

export const configureServices = (): void => {
    const envConfig = root.clientEnvConfig;
    if (envConfig) {
        const services = [GraphQlService];

        for (const service in services) {
            if (!Object.prototype.hasOwnProperty.call(services, service)) continue;
            services[service].configure(envConfig);
        }
    }
};
